@if (sound.isSoundOff()) {
  <input type="checkbox" (click)="sound.switchSound()" class="custom-control-input" id="switch8" />
}
@if (!sound.isSoundOff()) {
  <input type="checkbox" (click)="sound.switchSound()" class="custom-control-input active" id="switch8" checked />
}
<label class="custom-control-label" for="switch8" [class.active]="!sound.isSoundOff()">
  {{ 'web.sound_switch' | translate | transinit }}</label
  >
